import React, { useEffect, useState, useContext, useRef } from "react";
import apiClient from "../../ApiEndpoint/apiClient";
import { Table, Tabs, Tooltip, Input, Popover, Tag, Select, message } from "antd";
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { DownloadOutlined } from '@ant-design/icons';
import "./datatable.css";
import apiUrl from "../../ApiEndpoint/config";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import { from, of, Subject } from 'rxjs';
import { switchMap, catchError, tap, debounceTime, filter } from 'rxjs/operators';
import qs from 'qs';


const { TabPane } = Tabs;
const { Option } = Select;

const DataTable = ({ setPlantCoordinates, setProjectCoordinates }) => {
    const [siteData, setSiteData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 100; // Show 100 records per page
    const { groupName, sic_code, industry, state, county, city, register_Id, setRegisterid, setMarkerLoc, selectedRegistryId, setSelectedRegistryId, projectList, setProjectList } = useContext(RegisterIdContext);
    const { setProjectId, projectId, status, setShowFilterBar, refineSearchActive, refineSearchPlantFiltersData, selectedPlantMarker, selectedPlantId,
        setRefineSearchPlantID, setIsFacilitiesEmpty, setPlantObject, setTableFacilityObject, refineSearchEPAFiltersData, setGroupName, setRefineSearchProjectFiltersData, refineSearchProjectFiltersData, activeRefineSearchType, showProjectTable, setShowProjectTable } = useContext(RegisterIdContext); // Import projectId and setProjectId from context
    const [opportunityData, setOpportunityData] = useState([]);
    const [opportunityLoading, setOpportunityLoading] = useState(true);
    const [opportunityPage, setOpportunityPage] = useState(1);
    const [opportunityTotalCount, setOpportunityTotalCount] = useState(0); // Set a default or update it from API
    const opportunityPageSize = 100;
    const [acccountName, setAcccountName] = useState(null);
    const [oppName, setOppName] = useState(null);
    const [oppDesc, setOppDesc] = useState(null);
    const [contactName, setContactName] = useState(null);
    const searchSubjectRef = useRef(new Subject());
    const [hasDownloaded, setHasDownloaded] = useState(true);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [opsortColumn, setSortColumnOp] = useState(null);
    const [opsortOrder, setSortOrderOp] = useState(null);
    const projectPageSize = 1000;
    const [projectData, setProjectData] = useState([]);
    const [projectPage, setProjectPage] = useState(1);
    const [projectTotalCount, setProjectTotalCount] = useState(0);
    const [projectLoading, setProjectLoading] = useState(false);
    const [projectSearchFilters, setProjectSearchFilters] = useState({});
    const [projectApiFailed, setProjectApiFailed] = useState(false);

    //plant table states
    const [plantLoader, setPlantLoader] = useState(true);
    const [plantResults, setPlantResults] = useState([]);
    const [plantTotalCount, setPlantTotalCount] = useState(0);
    const [plantCurrentPage, setPlantCurrentPage] = useState(1);
    const [plantOffset, setPlantOffset] = useState(0);
    const plantPageSize = 100;
    const [selectedPlantID, setSelectedPlantID] = useState(null);
    const [plantTableLoader, setPlantTableLoader] = useState(true)



    //Refine Search Project Start
    const [refineProjectResults, setRefineProjectResults] = useState([]);
    const [refineProjectTotalCount, setRefineProjectTotalCount] = useState(0);
    const [refineProjectCurrentPage, setRefineProjectCurrentPage] = useState(1);
    const [refineProjectOffset, setRefineProjectOffset] = useState(0);
    const refineProjectPageSize = 100;
    const [refineProjectLoader, setRefineProjectLoader] = useState(true);
    const [selectedProjectID, setSelectedProjectID] = useState(null);



    const handleDownloadCSV = async () => {
        const tobeDownload = 5000;
        if (totalCount > tobeDownload && hasDownloaded) {
            toast.warning(`Only ${tobeDownload} records can be downloaded.Please refine your search criteria`);
            return;
        }

        try {
            setHasDownloaded(false);
            const params = {
                offset: 0,
                limit: tobeDownload,
                // sort_column: 'FAC_NAME',      // Add this
                // sort_order: 'desc',
            };

            if (groupName) params.group_name = groupName;
            if (sic_code) params.sic_code = sic_code;
            if (industry) params.industry = industry;
            if (state) params.state = state;
            if (county) params.county = county;
            if (city) params.city = city;
            if (register_Id) params.registry_id = register_Id;
            const epaFilters = [
                "sdwa_major_viol",
                "cwa_major_viol",
                "rcra_major_viol",
                "permit_comp_status",
                "min_avg_flow",
                "min_dmr",
                "min_design_flow",
                "major_minor_status",
                "facility_type"
            ];

            epaFilters.forEach(key => {
                if (refineSearchEPAFiltersData[key]) {
                    params[key] = refineSearchEPAFiltersData[key];
                }
            });

            // Inject sorting params dynamically
            if (sortColumn) params.sort_column = sortColumn;
            if (sortOrder) params.sort_order = sortOrder === "ascend" ? "asc" : "desc";

            const response = await apiClient.get(`${apiUrl}/facility_info/export`, {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'facility_data.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success('Download success!', {
                position: 'top-right',
                duration: 5, // Duration in seconds
            });;


        } catch (error) {
            console.error('Failed to download CSV:', error);
            toast.error('Download failed. Please try again.');
        } finally {
            setHasDownloaded(true);
        }
    };



    const handleOpportunityDownload = async () => {
        const tobeDownload = 5000;
        if (opportunityTotalCount > tobeDownload && hasDownloaded) {
            toast.warning(`Only ${tobeDownload} records can be downloaded. Please refine your search criteria`);
            return;
        }

        try {
            setHasDownloaded(false);
            const params = {
                offset: 0,
                limit: tobeDownload,
            };

            // Add opportunity-specific filters here if any (e.g., status, opportunity type, etc.)
            if (groupName) params.group_name = groupName;
            if (sic_code.length > 0) params.sic_code = sic_code;
            if (industry) params.industry = industry;
            if (state) params.state = state;
            if (county) params.county = county;
            if (city) params.city = city;
            if (register_Id) params.registry_id = register_Id;


            // Inject sorting params dynamically
            if (opsortColumn) params.sort_column = opsortColumn;
            if (opsortOrder) params.sort_order = opsortOrder === "ascend" ? "asc" : "desc";
            const response = await apiClient.get(`${apiUrl}/opportunity_list_table/export`, {
                params,
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'opportunity_data.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success('Download success!', {
                position: 'top-right',
                duration: 5,
            });

        } catch (error) {
            console.error('Failed to download CSV:', error);
            toast.error('Download failed. Please try again.');
        } finally {
            setHasDownloaded(true);
        }
    };



    const siteColumns = [
        { title: "Parent company name", dataIndex: "COMPANY_NAME", key: "COMPANY_NAME", sortColumn: "group_names", sorter: true, fixed: 'left' },
        {
            title: "Facility Name",
            dataIndex: "FACILITY_NAME",
            key: "FACILITY_NAME",
            sortColumn: "FACILITY_NAME",
            sorter: true,
            render: (text, record) => (
                <span
                    style={{ color: '#1890ff', cursor: 'pointer' }}
                    onClick={() => {
                        setMarkerLoc(record.fullObject.REGISTRY_ID)
                        setRegisterid([record.fullObject]);
                        setSelectedRegistryId(record.fullObject.REGISTRY_ID);
                        setShowProjectTable(false);
                    }}
                >
                    {text}
                </span>
            ),
            fixed: 'left',
        },
        { title: "Industry", dataIndex: "INDUSTRY", key: "INDUSTRY", sortColumn: "INDUSTRY", sorter: true, fixed: 'left' },

        // {
        //     title: (
        //         <div className="custom-column-title">
        //             <div className="label-text" style={{ marginLeft: "4px" }}>Prospect Category</div>
        //             <Select
        //                 className="prospect-dropdown"
        //                 showSearch
        //                 allowClear
        //                 placeholder="Select Category"
        //                 value={status}
        //                 onChange={(value) => setStatus(value)}
        //                 optionFilterProp="children"
        //                 // filterOption={(input, option) =>
        //                 //     option?.children?.toLowerCase().includes(input.toLowerCase())
        //                 // }
        //                 filterOption={(input, option) =>
        //                     (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        //                 }
        //                 style={{ width: '9rem', padding: '3px' }}
        //                 optionLabelProp="label"
        //             >
        //                 <Option value="High" label="HIGH">
        //                     <div className="status-option high-option">
        //                         <span className="status-dot high-dot" />
        //                         <span className="status-text">HIGH</span>
        //                     </div>
        //                 </Option>

        //                 <Option value="Medium" label="MEDIUM">
        //                     <div className="status-option medium-option">
        //                         <span className="status-dot medium-dot" />
        //                         <span className="status-text">MEDIUM</span>
        //                     </div>
        //                 </Option>

        //                 <Option value="Low" label="LOW">
        //                     <div className="status-option low-option">
        //                         <span className="status-dot low-dot" />
        //                         <span className="status-text">LOW</span>
        //                     </div>
        //                 </Option>
        //             </Select>
        //         </div>
        //     ),
        //     dataIndex: "PROSPECT_CATEGORY",
        //     key: "PROSPECT_CATEGORY",
        //     render: (value) => {
        //         let bgColor = '';
        //         let label = '';

        //         switch (value?.toLowerCase()) {
        //             case 'high':
        //                 bgColor = '#73d13d26';
        //                 label = 'High';
        //                 break;
        //             case 'medium':
        //                 bgColor = '#ffa50026';
        //                 label = 'Medium';
        //                 break;
        //             case 'low':
        //                 bgColor = '#ff000026';
        //                 label = 'Low';
        //                 break;
        //             default:
        //                 bgColor = '#b0c4de26';
        //                 label = 'N/A';
        //         }

        //         return (
        //             <Tag
        //                 style={{
        //                     backgroundColor: bgColor,
        //                     textTransform: 'capitalize',
        //                     padding: '2px 10px',
        //                     borderRadius: '4px',
        //                     marginLeft: '1.5rem'
        //                 }}
        //             >
        //                 {label}
        //             </Tag>
        //         );
        //     },
        //     fixed: 'left',
        // },
        { title: "State", dataIndex: "STATE_NAME", key: "STATE_NAME", sortColumn: "FAC_STATE", sorter: true },
        { title: "City Name", dataIndex: "CITYNAME", key: "CITYNAME", sortColumn: "FAC_CITY", sorter: true },
        { title: "Street Address", dataIndex: "STREETADDRESS", key: "STREETADDRESS", sortColumn: "FAC_STREET", sorter: true },
        { title: "HeadCount", dataIndex: "HEADCOUNT", key: "HEADCOUNT" },
        { title: "Area (sqft)", dataIndex: "AREA", key: "AREA" },
        { title: "Union", dataIndex: "UNION", key: "UNION" },
        { title: "Year of Completion", dataIndex: "YEAR", key: "YEAR" },
        { title: "Energy Star Score", dataIndex: "ENERGY", key: "ENERGY" },
        { title: "Cost of Water", dataIndex: "WATER", key: "WATER" },
        { title: "Industrial Cost of Electricity", dataIndex: "ELECTRICITY", key: "ELECTRICITY", sortColumn: "electricity_consumption_price", sorter: true },
        { title: "SIC Code", dataIndex: "CODE", key: "CODE", sortColumn: "SIC_CODE", sorter: true },
        { title: "Veolia Site", dataIndex: "VEOLIASITE", key: "VEOLIASITE" },

    ];


    useEffect(() => {
        // Whenever a filter changes, reset the current page to 1
        setCurrentPage(1);
        setProjectPage(1);
    }, [sic_code, groupName, industry, state, county, city, register_Id]);


    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchData$ = of({
            offset: (currentPage - 1) * pageSize,
            limit: pageSize,
            ...(groupName && { group_name: groupName }),
            ...(sic_code?.length && { sic_code }),
            // ...(industry?.length && { industry }),
            ...(status && { prospect_category: status }),
            ...(state && { state }),
            ...(county && { county }),
            ...(city && { city }),
            ...(register_Id && { registry_id: register_Id }),
            ...(sortColumn && { sort_column: sortColumn }),
            ...(sortOrder && { sort_order: sortOrder === "ascend" ? "asc" : "desc" }),
            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type }),
        }).pipe(
            debounceTime(500),
            switchMap((params) =>
                from(
                    apiClient.get(`${apiUrl}/facility_info`, {
                        params,
                        paramsSerializer: (params) =>
                            qs.stringify(params, { arrayFormat: "repeat" }),
                        signal,
                    })
                ).pipe(
                    catchError((error) => {
                        console.error("Error fetching facility data:", error);
                        return of(null);
                    })
                )
            )
        );

        const subscription = fetchData$.subscribe((response) => {
            if (response?.data?.data) {
                const formattedData = response.data.data.map((item, index) => ({
                    key: (currentPage - 1) * pageSize + index + 1,
                    COMPANY_NAME: item.group_names || "N/A",
                    FACILITY_NAME: item.FAC_NAME || "N/A",
                    INDUSTRY: item.INDUSTRY || "N/A",
                    // PROSPECT_CATEGORY: item.prospect_category,
                    STATE_NAME: item.STATE_NAME || "N/A",
                    CITYNAME: item.FAC_CITY || "N/A",
                    STREETADDRESS: item.FAC_STREET || "N/A",
                    HEADCOUNT: "N/A",
                    AREA: "N/A",
                    UNION: "N/A",
                    YEAR: "N/A",
                    ENERGY: "N/A",
                    WATER: "N/A",
                    ELECTRICITY: item?.electricity_consumption_price || "N/A",
                    CODE: item.SIC_CODE || "N/A",
                    VEOLIASITE: item.IS_VEOLIA_SITE === true ? "Yes" : "No",
                    fullObject: item,
                }));
                setSiteData(formattedData);
                setTotalCount(response.data.total_count || 1000);
            }
            setLoading(false);
        });

        setLoading(true);

        return () => {
            controller.abort();           // cancel pending fetch
            subscription.unsubscribe();   // cancel RxJS stream
        };
    }, [currentPage, pageSize, groupName, sic_code, industry, state, county, city, register_Id, sortColumn, sortOrder, status, refineSearchEPAFiltersData]); // Fetch new data when the page or filters change


    //Opportunity table columns
    const opportunityColumns = [
        {
            title: (
                <div>
                    <div className="table-heading">Account Name</div>
                    <Input
                        size="small"
                        placeholder="Account Name"
                        onChange={(e) => handleOppertunitySearch(e.target.value, 'accountName')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),

            dataIndex: "account_name",
            key: "account_name",
            sortColumn: "account_name",
            sorter: true,
            fixed: 'left',
        },
        { title: "Account ID", dataIndex: "account_id", key: "account_id", sortColumn: "account_id", sorter: true, fixed: 'left', },
        {
            title: (
                <div>
                    <div className="table-heading">Opportunity Name</div>
                    <Input
                        size="small"
                        placeholder="Opportunity Name"
                        onChange={(e) => handleOppertunitySearch(e.target.value, 'opportunityName')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "opportunity_name",
            key: "opportunity_name",
            sortColumn: "opportunity_name", sorter: true, fixed: 'left',
        },


        {
            title: (
                <div>
                    <div className="table-heading">Description</div>
                    <Input
                        size="small"
                        placeholder="Description"
                        onChange={(e) => handleOppertunitySearch(e.target.value, 'description')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}

                    />
                </div>
            ),
            dataIndex: "description",
            key: "description",
            sortColumn: "description", sorter: true,
            render: (text) => (
                <Tooltip
                    title={
                        <div
                            style={{
                                maxHeight: 300,
                                overflowY: "auto",
                                whiteSpace: "normal",
                            }}
                        >
                            {text}
                        </div>
                    }
                >
                    <div
                        style={{
                            maxWidth: 300,
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                        }}
                    >
                        {text}
                    </div>
                </Tooltip>
            ),
        },
        { title: "Opportunity Team Member", dataIndex: "opportunity_team_member", key: "opportunity_team_member", sortColumn: "opportunity_team_member", sorter: true },
        {
            title: (
                <div>
                    <div className="table-heading">Main Contact</div>
                    <Input
                        size="small"
                        placeholder="Main Contact"
                        onChange={(e) => handleOppertunitySearch(e.target.value, 'contactName')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "main_contact",
            key: "main_contact",
            sortColumn: "main_contact", sorter: true
        },
        { title: "Business Unit", dataIndex: "business_unit", key: "business_unit", sortColumn: "business_unit", sorter: true },
        { title: "Region Branch", dataIndex: "region_branch", key: "region_branch", sortColumn: "region_branch", sorter: true },
        { title: "Business Type", dataIndex: "business_type", key: "business_type", sortColumn: "business_type", sorter: true },
        { title: "Total Amount", dataIndex: "total_amount", key: "total_amount", sortColumn: "total_amount", sorter: true },
        { title: "Stage", dataIndex: "stage", key: "stage", sortColumn: "stage", sorter: true },
        { title: "Profitability(%)", dataIndex: "profitability", key: "profitability", sortColumn: "profitability", sorter: true },
        { title: "Close Date", dataIndex: "close_date", key: "close_date", sortColumn: "close_date", sorter: true },
        { title: "Start Date", dataIndex: "start_date", key: "start_date", sortColumn: "start_date", sorter: true },
        { title: "Comment", dataIndex: "competitor_comment", key: "competitor_comment", sortColumn: "competitor_comment", sorter: true },
        { title: "Age(days)", dataIndex: "age", key: "age", sortColumn: "age", sorter: true },
    ];

    useEffect(() => {
        const subscription = searchSubjectRef.current
            .pipe(debounceTime(300)) // wait 300ms after last input
            .subscribe(({ value, type }) => {
                switch (type) {
                    case 'accountName':
                        setAcccountName(value);
                        break;
                    case 'opportunityName':
                        setOppName(value);
                        break;
                    case 'description':
                        setOppDesc(value);
                        break;
                    case 'contactName':
                        setContactName(value);
                        break;
                    default:
                        break;
                }
            });

        return () => subscription.unsubscribe();
    }, [acccountName, oppName, oppDesc, contactName]);

    const handleOppertunitySearch = (value, type) => {
        searchSubjectRef.current.next({ value, type });
    };

    useEffect(() => {
        const observable$ = from([null]).pipe(
            tap(() => setOpportunityLoading(true)),

            switchMap(() => {
                const params = {
                    offset: (opportunityPage - 1) * opportunityPageSize,
                    limit: opportunityPageSize,
                };

                if (state) params.state = state;
                if (city) params.city = city;
                if (groupName) params.group_name = groupName;
                if (acccountName) params.account_name = acccountName;
                if (oppName) params.opportunity_name = oppName;
                if (oppDesc) params.opp_description = oppDesc;
                if (contactName) params.contact_name = contactName;
                if (opsortColumn) params.sort_column = opsortColumn;
                if (opsortOrder) {
                    params.sort_order = opsortOrder === "ascend" ? "asc" : "desc";
                }
                return from(apiClient.get(`${apiUrl}/opportunity_list_table`, { params }));
            }),

            switchMap((response) => {
                const list = response.data?.opportunity_list || [];

                const formattedOpportunities = list.map((item, index) => ({
                    key: (opportunityPage - 1) * opportunityPageSize + index + 1,
                    account_name: item.ACCOUNTLONGNAME__C || 'N/A',
                    account_id: item.ACCOUNT_ID || 'N/A',
                    opportunity_name: item.NAME || 'N/A',
                    description: item.DESCRIPTION || 'N/A',
                    opportunity_team_member: item.OPPORTUNITY_TEAM_MEMBERS__C || 'N/A',
                    main_contact: item.CONTACT_NAME || 'N/A',
                    business_unit: item.BUSINESS_UNIT__C || 'N/A',
                    region_branch: item.REGION_BRANCH__C || 'N/A',
                    business_type: item.BUSINESS_TYPE__C || 'N/A',
                    total_amount: item.AMOUNT || 'N/A',
                    stage: item.STAGE_NAME || 'N/A',
                    profitability: item.PROBABILITY || 'N/A',
                    close_date: item.CLOSE_DATE?.split('T')[0] || 'N/A',
                    start_date: item.PROJECT_START_DATE__C?.split('T')[0] || 'N/A',
                    competitor_comment: item.COMPETITOR_COMMENT__C || 'N/A',
                    age: item.AGE__C || 'N/A',
                }));

                setOpportunityData(formattedOpportunities);
                setOpportunityTotalCount(response.data.total_count || 100);
                return of(null); // continue the stream
            }),

            catchError((err) => {
                console.error('Error fetching opportunity data:', err);
                return of(null); // recover gracefully
            }),

            tap(() => setOpportunityLoading(false))
        );

        const subscription = observable$.subscribe();

        return () => {
            // Cleanup on component unmount or dependency change
            subscription.unsubscribe();
        };
    }, [opportunityPage, state, city, opportunityPageSize, groupName, acccountName, oppName, oppDesc, contactName, opsortColumn, opsortOrder]);

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.order) {
            const sortedColumn = siteColumns.find(col => col.dataIndex === sorter.field);
            setSortColumn(sortedColumn?.sortColumn || sorter.field);
            setSortOrder(sorter.order);
        } else {
            setSortColumn(null);
            setSortOrder(null);
        }
    };

    const handleTableChangeOp = (pagination, filters, sorter) => {
        if (sorter.order) {
            const sortedColumn = opportunityColumns.find(col => col.dataIndex === sorter.field);
            setSortColumnOp(sortedColumn?.sortColumn || sorter.field);
            setSortOrderOp(sorter.order);
        } else {
            setSortColumnOp(null);
            setSortOrderOp(null);
        }
    };



    //Project data api integration
    const projectColumns = [

        {
            title: (
                <div>
                    <div className="table-heading">Project Name</div>
                    <Input
                        size="small"
                        placeholder="Project Name"
                        onChange={(e) =>
                            handleProjectSearch(e.target.value, "projectName")
                        }
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "projectName",
            key: "projectName",
            sorter: (a, b) => a.projectName?.localeCompare(b.projectName || "") ?? 0,
            render: (text, record) => {
                if (record.isErrorRow) {
                    return {
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "40px 0",
                                    width: "100%",
                                    color: "#999",
                                    fontSize: "16px",
                                }}
                            >
                                {!projectLoading && (
                                    <>
                                        <ReloadOutlined
                                            style={{
                                                fontSize: 32,
                                                color: "#1890ff",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                if (!projectLoading && groupName) {
                                                    loadProjectData();
                                                }
                                            }}
                                        />
                                        <div style={{ marginTop: 12 }}>
                                            Due to IIR technical data failure, click on the reload icon
                                        </div>
                                    </>
                                )}

                            </div>
                        ),
                        props: {
                            colSpan: projectColumns.length, // span entire row
                        },
                    };
                }

                return (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer" }}
                        onClick={() => handleProjectClick(record?.projectId)}
                    >
                        {text}
                    </span>
                );
            },
            fixed: "left",
        },
        {
            title: (
                <div>
                    <div className="table-heading">Total Investment</div>
                    <Input
                        size="small"
                        placeholder="Total Investment"
                        onChange={(e) => handleProjectSearch(e.target.value, 'TotalInvestment')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "TotalInvestment",
            key: "TotalInvestment",
            sorter: (a, b) => {
                const numA = parseFloat(a.TotalInvestment.replace(/[^0-9.-]+/g, ""));
                const numB = parseFloat(b.TotalInvestment.replace(/[^0-9.-]+/g, ""));
                return numA - numB;
            },
        },
        {
            title: (
                <div>
                    <div className="table-heading">Project Status</div>
                    <Input
                        size="small"
                        placeholder="Status"
                        onChange={(e) => handleProjectSearch(e.target.value, 'ProjectStatus')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "ProjectStatus",
            key: "ProjectStatus",
            sorter: (a, b) => a.ProjectStatus.localeCompare(b.ProjectStatus),

        },
        {
            title: (
                <div>
                    <div className="table-heading">Project Owner</div>
                    <Input
                        size="small"
                        placeholder="Owner"
                        onChange={(e) => handleProjectSearch(e.target.value, 'ProjectOwner')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "ProjectOwner",
            key: "ProjectOwner",
            sorter: (a, b) => a.ProjectOwner.localeCompare(b.ProjectOwner),

        },
        {
            title: (
                <div>
                    <div className="table-heading">Plant Name</div>
                    <Input
                        size="small"
                        placeholder="Plant Name"
                        onChange={(e) => handleProjectSearch(e.target.value, 'PlantName')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "PlantName",
            key: "PlantName",
            sorter: (a, b) => a.PlantName.localeCompare(b.PlantName),

        },
        {
            title: (
                <div>
                    <div className="table-heading">City</div>
                    <Input
                        size="small"
                        placeholder="City"
                        onChange={(e) => handleProjectSearch(e.target.value, 'City')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "City",
            key: "City",
            sorter: (a, b) => a.City.localeCompare(b.City),

        },
        {
            title: (
                <div>
                    <div className="table-heading">State</div>
                    <Input
                        size="small"
                        placeholder="State"
                        onChange={(e) => handleProjectSearch(e.target.value, 'State')}
                        prefix={<SearchOutlined style={{ color: "#aaa" }} />}
                    />
                </div>
            ),
            dataIndex: "State",
            key: "State",
            sorter: (a, b) => a.State.localeCompare(b.State),

        },
    ];

    const handleProjectClick = (projectId) => {
        setProjectId(projectId);
        setMarkerLoc(null)
    };


    //Initial project data load
    useEffect(() => {
        const projectData = loadProjectData();
        return projectData;
    }, [groupName, projectPage]);

    const loadProjectData = () => {
        const controller = new AbortController();
        const signal = controller.signal;

        const subscription = of({ groupName, projectPage })
            .pipe(
                filter(({ groupName }) => !!groupName),
                tap(() => setProjectLoading(true)),
                switchMap(({ groupName, projectPage }) => {
                    const params = {
                        offset: (projectPage - 1) * projectPageSize,
                        limit: projectPageSize,
                        plantParentName: groupName,
                    };

                    return from(
                        apiClient.get(`${apiUrl}/projects-summary`, {
                            params,
                            paramsSerializer: (params) =>
                                qs.stringify(params, { arrayFormat: "repeat" }),
                            signal,
                        })
                    ).pipe(
                        catchError((error) => {
                            console.error("Error fetching project data:", error);
                            setProjectApiFailed(true);
                            return of(null);
                        })
                    );
                })
            )
            .subscribe((response) => {
                if (response?.data?.projects) {
                    setProjectApiFailed(false);
                    const formatted = response.data.projects.map((item, index) => ({
                        key: (projectPage - 1) * projectPageSize + index + 1,
                        projectName: item.projectName || "N/A",
                        TotalInvestment:
                            typeof item.localTiv === "number"
                                ? new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                }).format(item.localTiv)
                                : "N/A",
                        ProjectStatus: item.projectStatusDesc || "N/A",
                        ProjectOwner: item.projectOwnerName || "N/A",
                        PlantName: item.plantName || "N/A",
                        City: item.plantPhysicalAddress?.city || "N/A",
                        State: item.plantPhysicalAddress?.stateName || "N/A",
                        projectId: item?.projectId || "N/A",
                    }));

                    const projectIdNameArray = response.data.projects.map((item) => ({
                        projectId: item.projectId,
                        projectName: item.projectName,
                        projectStatus: item.projectStatusDesc,
                    }));

                    setProjectList(projectIdNameArray);
                    setProjectData(formatted);
                    setProjectTotalCount(response.data.totalCount || 1000);
                } else {
                    setProjectData([]);
                    setProjectTotalCount(0);
                }

                setProjectLoading(false);
            });

        return () => {
            controller.abort();
            subscription.unsubscribe();
        };
    };

    //project search function
    const handleProjectSearch = (value, key) => {
        setProjectSearchFilters((prev) => ({
            ...prev,
            [key]: value.toLowerCase(),
        }));
    };

    ///Apply Filtering  Table Render:
    const filteredProjectData = projectData.filter((item) => {
        return Object.keys(projectSearchFilters).every((key) => {
            if (!projectSearchFilters[key]) return true;
            return String(item[key] || '')
                .toLowerCase()
                .includes(projectSearchFilters[key]);
        });
    });

    //download project table
    const handleProjectDownload = async () => {
        const tobeDownloadCount = 5000;

        if (projectTotalCount > tobeDownloadCount && hasDownloaded) {
            toast.warning(`Only ${tobeDownloadCount} records can be downloaded. Please refine your search criteria.`);
            return;
        }

        try {
            setHasDownloaded(false);

            const params = {
                offset: 0,
                limit: tobeDownloadCount,
                plantParentName: groupName,
            };

            const response = await apiClient.get(`${apiUrl}/projects-summary/export`, {
                params,
                responseType: 'blob',
            });

            // Extract filename from content-disposition header
            const disposition = response.headers['content-disposition'];
            let filename = 'project_details.csv';
            if (disposition && disposition.includes('filename=')) {
                filename = disposition.split('filename=')[1].replace(/['"]/g, '');
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success('Download success!', {
                position: 'top-right',
                duration: 5,
            });
        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Download failed. Please try again.');
        } finally {
            setHasDownloaded(true);
        }
    };


    //plant datatable
    const plantColumns = [
        {
            title: <div className="table-heading">Plant Name</div>,
            dataIndex: "plantName",
            key: "plantName",
            render: (text, record) => (
                <span
                    className="plant-name-blue"
                    onClick={() => {
                        setSelectedPlantID(record.plantId);   // highlight row
                        fetchPlantDetails(record.plantId);        // ✅ call API here
                    }}
                >
                    {text}
                </span>
            ),
        },
        {
            title: <div className="table-heading">Plant Status</div>,
            dataIndex: "plantStatusDesc",
            key: "plantStatusDesc",
        },
        {
            title: <div className="table-heading">Industry Description</div>,
            dataIndex: "industryCodeDesc",
            key: "industryCodeDesc",
        },
        {
            title: <div className="table-heading">Sic Description</div>,
            dataIndex: "primarySicDesc",
            key: "primarySicDesc",
        },
        {
            title: <div className="table-heading">State</div>,
            dataIndex: ["physicalAddress", "stateName"],
            key: "stateName",
        },
        {
            title: <div className="table-heading">City</div>,
            dataIndex: ["physicalAddress", "city"],
            key: "city",
        },
        {
            title: <div className="table-heading">Country</div>,
            dataIndex: ["physicalAddress", "countryName"],
            key: "countryName",
        },
    ];

    useEffect(() => {
        const fetchPlants = async () => {
            // ✅ Block API call if no filters are selected
            if (!refineSearchPlantFiltersData || Object.values(refineSearchPlantFiltersData).every(v => v === null || v === undefined || v === "")) {
                setPlantResults([]);
                setPlantTotalCount(0);
                setPlantLoader(false);
                setPlantCoordinates([]); // clear map markers
                return;
            }

            setPlantLoader(true);  // clear the table

            try {
                const params = {
                    includeDetails: false,
                    limit: plantPageSize,
                    offset: plantOffset,
                    ...(refineSearchPlantFiltersData.plantStatusDesc && { plantStatusDesc: refineSearchPlantFiltersData.plantStatusDesc }),
                    ...(refineSearchPlantFiltersData.plantParentName && { plantParentName: refineSearchPlantFiltersData.plantParentName }),
                    ...(refineSearchPlantFiltersData.plantName && { plantName: refineSearchPlantFiltersData.plantName }),
                    ...(refineSearchPlantFiltersData.plantSectorDesc && { plantSectorDesc: refineSearchPlantFiltersData.plantSectorDesc }),
                    ...(refineSearchPlantFiltersData.actualCapacityMin && { actualCapacityMin: refineSearchPlantFiltersData.actualCapacityMin }),
                    ...(refineSearchPlantFiltersData.startupDateMin && { startupDateMin: refineSearchPlantFiltersData.startupDateMin }),
                    ...(refineSearchPlantFiltersData.startupDateMax && { startupDateMax: refineSearchPlantFiltersData.startupDateMax }),
                    ...(refineSearchPlantFiltersData.existingSqFtMin && { existingSqFtMin: refineSearchPlantFiltersData.existingSqFtMin }),
                    ...(refineSearchPlantFiltersData.employeeCountMin && { employeeCountMin: refineSearchPlantFiltersData.employeeCountMin }),
                    ...(refineSearchPlantFiltersData.physicalAddressCity && { physicalAddressCity: refineSearchPlantFiltersData.physicalAddressCity }),
                    ...(refineSearchPlantFiltersData.physicalAddressStateName && { physicalAddressStateName: refineSearchPlantFiltersData.physicalAddressStateName }),
                    ...(typeof refineSearchPlantFiltersData.operationsLaborPreference === 'number' && {
                        operationsLaborPreference: refineSearchPlantFiltersData.operationsLaborPreference,
                    }),

                };

                const response = await apiClient.get(`${apiUrl}/plants-summary`, {
                    params,
                    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
                });

                const responseData = response.data || {};
                setPlantResults(responseData.plants || []);
                setPlantTotalCount(responseData.totalCount || 0);
                // ✅ Extract latitude, longitude, and normalized isVeoliaSite
                const coordinates = (responseData.plants || [])
                    .filter((p) => p.latitude && p.longitude && p.plantName) // only valid coords
                    .map((p) => {
                        const isVeolia = p.facilities?.some((f) => f.isVeoliaSite === true) || false;
                        return {
                            lat: p.latitude,
                            lng: p.longitude,
                            plantname: p.plantName,
                            veoliaSite: isVeolia,
                            plantId: p.plantId
                        };
                    });
                setPlantCoordinates(coordinates);
            } catch (error) {
                console.error("API error:", error);
                setPlantResults([]);
                setPlantTotalCount(0);
            } finally {
                setPlantLoader(false);
            }
        };

        fetchPlants();
    }, [refineSearchPlantFiltersData, plantOffset]); // ✅ only runs when filters change

    const handlePlantTableChange = (pagination) => {
        setPlantCurrentPage(pagination.current);
        setPlantOffset((pagination.current - 1) * pageSize);
    };



    useEffect(() => {
        // Whenever a filter changes, reset the current page to 1
        if (selectedPlantMarker) {
            fetchPlantDetails(selectedPlantMarker);
        }
    }, [selectedPlantMarker]);

    const fetchPlantDetails = async (plantId) => {

        try {
            setPlantTableLoader(true)
            const params = {};
            // if (registerID) params.registryId = registerID;
            if (plantId) params.plantId = plantId;

            const { data } = await apiClient.get(`${apiUrl}/plants-detail`, { params });

            const plants = data?.plants || [];
            const facilities = data?.facilities || [];
            const isEmpty = facilities.length === 0;

            if (isEmpty) {
                setIsFacilitiesEmpty(isEmpty);
                setMarkerLoc(null)   // ✅ true if no facilities
            } else {
                const register_Id = facilities[0]?.registryId || null;
                const facilityResponse = await apiClient.get(`${apiUrl}/facility_info?registry_id=${register_Id}`);
                const facilityData = facilityResponse.data?.data || [];
                setRegisterid(facilityData);
                setRefineSearchPlantID(plants[0]?.plantId)
                setMarkerLoc(register_Id)
                setTableFacilityObject(facilities)
                setGroupName(facilityData[0].group_names)
            }
            setPlantObject(plants)


        } catch (error) {
            console.error("Error fetching plant details:", error);

        } finally {
            setPlantTableLoader(false)
        }
    };



    //refine search project-summmary api integration
    useEffect(() => {
        const fetchProject = async () => {
            // ✅ Block API call if no filters are selected
            if (!refineSearchProjectFiltersData || Object.values(refineSearchProjectFiltersData).every(v => !v)) {
                setRefineProjectResults([]);
                setRefineProjectTotalCount(0);
                setRefineProjectLoader(false);
                setProjectCoordinates([])// clear map markers
                return;
            }

            setRefineProjectLoader(true);  // clear the table

            try {
                const params = {
                    includeDetails: false,
                    limit: refineProjectPageSize,
                    offset: refineProjectOffset,
                    ...(refineSearchProjectFiltersData.projectName && { projectName: refineSearchProjectFiltersData.projectName }),
                    ...(refineSearchProjectFiltersData.projectStatusDesc && { projectStatusDesc: refineSearchProjectFiltersData.projectStatusDesc }),
                    ...(refineSearchProjectFiltersData.plantName && { plantName: refineSearchProjectFiltersData.plantName }),
                    ...(refineSearchProjectFiltersData.plantParentName && { plantParentName: refineSearchProjectFiltersData.plantParentName }),
                    ...(refineSearchProjectFiltersData.physicalAddressStateName && { physicalAddressStateName: refineSearchProjectFiltersData.physicalAddressStateName }),
                    ...(refineSearchProjectFiltersData.physicalAddressCity && { physicalAddressCity: refineSearchProjectFiltersData.physicalAddressCity }),
                    ...(refineSearchProjectFiltersData.industryCodeDesc && { industryCodeDesc: refineSearchProjectFiltersData.industryCodeDesc }),
                    ...(refineSearchProjectFiltersData.plantSectorDesc && { plantSectorDesc: refineSearchProjectFiltersData.plantSectorDesc }),
                    ...(refineSearchProjectFiltersData.scope && { scope: refineSearchProjectFiltersData.scope }),
                    ...(refineSearchProjectFiltersData.tivMin && { tivMin: refineSearchProjectFiltersData.tivMin }),
                    ...(refineSearchProjectFiltersData.projectTypeDesc && { projectTypeDesc: refineSearchProjectFiltersData.projectTypeDesc }),
                    ...(refineSearchProjectFiltersData.projectFuelTypeDesc && { projectFuelTypeDesc: refineSearchProjectFiltersData.projectFuelTypeDesc }),
                    ...(refineSearchProjectFiltersData.liveDateMin && { liveDateMin: refineSearchProjectFiltersData.liveDateMin }),
                    ...(refineSearchProjectFiltersData.releaseDateMin && { releaseDateMin: refineSearchProjectFiltersData.releaseDateMin }),
                    ...(refineSearchProjectFiltersData.plannedCapacityMin && { plannedCapacityMin: refineSearchProjectFiltersData.plannedCapacityMin }),
                    ...(refineSearchProjectFiltersData.newSqFtMin && { newSqFtMin: refineSearchProjectFiltersData.newSqFtMin }),
                    ...(refineSearchProjectFiltersData.projectProbability && { projectProbability: refineSearchProjectFiltersData.projectProbability }),
                    ...(refineSearchProjectFiltersData.constructionLaborPreference && { constructionLaborPreference: refineSearchProjectFiltersData.constructionLaborPreference }),
                    ...(refineSearchProjectFiltersData.operationsLaborPreference && { operationsLaborPreference: refineSearchProjectFiltersData.operationsLaborPreference }),
                };

                const response = await apiClient.get(`${apiUrl}/projects-summary`, {
                    params,
                    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
                });

                const responseData = response.data || {};
                // ✅ Extract latitude, longitude, and VeoliaSite flag
                const projectCoordinates = (responseData.projects || [])
                    .filter(p => p.plantLatitude && p.plantLongitude) // only valid coords
                    .map(p => {
                        const isVeolia = p.facilities?.some(f => f.isVeoliaSite === true) || false;

                        return {
                            lat: p.plantLatitude,
                            lng: p.plantLongitude,
                            projectName: p.projectName,
                            veoliaSite: isVeolia,
                            projectId: p.projectId
                        };
                    });

                setProjectCoordinates(projectCoordinates)

                setRefineProjectResults(responseData.projects || []);
                setRefineProjectTotalCount(responseData.totalCount || 0);

            } catch (error) {
                console.error("API error:", error);
                setRefineProjectResults([]);
                setRefineProjectTotalCount(0);
            } finally {
                setRefineProjectLoader(false);
            }
        };
        fetchProject()
    }, [refineSearchProjectFiltersData, refineProjectOffset]); // ✅ only runs when filters change

    const handleProjectTableChange = (pagination) => {
        setRefineProjectCurrentPage(pagination.current);
        setRefineProjectOffset((pagination.current - 1) * pageSize);
    };

    //Total investment represnt in us format
    const formatTotalInvestment = (value) => {
        return typeof value === "number"
            ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value)
            : "N/A";
    };
    const refineProjectColumns = [

        {
            title: "Project Name",
            dataIndex: "projectName",
            key: "projectName",
            render: (text, record) => (
                <span
                    className="plant-name-blue"
                    onClick={() => {

                        setSelectedProjectID(record.projectId);//open the new project deatils
                        setProjectId(record.projectId)   // highlight row
                        setRefineSearchPlantID(record.plantId)
                    }}
                >
                    {text}
                </span>
            ),

        },
        {
            title: "Total Investment",
            dataIndex: "localTiv",
            key: "localTiv",
            render: (value) => formatTotalInvestment(value),

        },
        {
            title: "Project Status",
            dataIndex: "projectStatusDesc",
            key: "projectStatusDesc",

        },
        {
            title: "Project Owner",
            dataIndex: "projectOwnerName",
            key: "projectOwnerName",

        },
        {
            title: "Plant Name",
            dataIndex: "plantName",
            key: "plantName",

        },
        {
            title: "City",
            dataIndex: ["plantPhysicalAddress", "city"],
            key: "city",

        },
        {
            title: "State",
            dataIndex: ["plantPhysicalAddress", "stateName"],
            key: "stateName",

        },
    ];


    //dowmload refine search plant sites
    const handlePlantDownload = () => {
        if (!plantResults || plantResults.length === 0) {
            message.warning("No plant data available to download");
            return;
        }

        // Pick only required fields
        const csvData = plantResults.map((p) => ({
            "Plant Name": p.plantName || "",
            "Plant Status": p.plantStatusDesc || "",
            "Industry Description": p.industryCodeDesc || "",
            "Sic Description": p.primarySicDesc || "",
            "State": p.physicalAddress?.stateName || "",
            "City": p.physicalAddress?.city || "",
            "Country": p.physicalAddress?.countryName || "",
        }));

        // Convert array of objects → CSV
        const headers = Object.keys(csvData[0]).join(",") + "\n";
        const rows = csvData.map((row) =>
            Object.values(row)
                .map((val) => `"${String(val).replace(/"/g, '""')}"`) // escape quotes
                .join(",")
        );
        const csvString = headers + rows.join("\n");

        // Trigger download
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "IIR_Plant/Sites.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleRefineProjectDownload = () => {
        if (!refineProjectResults || refineProjectResults.length === 0) {
            message.warning("No project data available to download");
            return;
        }

        // Pick only required fields
        const csvData = refineProjectResults.map((p) => ({
            "Project Name": p.projectName || "",
            "Total Investment": p.localTiv || "",
            "Project Status": p.projectStatusDesc || "",
            "Project Owner": p.projectOwnerName || "",
            "Plant Name": p.plantName || "",
            "City": p.plantPhysicalAddress?.city || "",
            "State": p.plantPhysicalAddress?.stateName || "",
        }));

        // Convert array of objects → CSV
        const headers = Object.keys(csvData[0]).join(",") + "\n";
        const rows = csvData.map((row) =>
            Object.values(row)
                .map((val) => `"${String(val).replace(/"/g, '""')}"`) // escape quotes
                .join(",")
        );
        const csvString = headers + rows.join("\n");

        // Trigger download
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "IIR_Project.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <>
            <Tabs defaultActiveKey="1">
                {!refineSearchActive && (
                    <TabPane tab="Sites" key="1">
                        <Popover
                            content="Max 5000 records can be downloaded"
                            placement="top"
                            trigger="hover"
                        >
                            <DownloadOutlined
                                style={{
                                    fontSize: 20,
                                    color: !hasDownloaded ? 'gray' : '#1890ff',
                                    cursor: !hasDownloaded ? 'not-allowed' : 'pointer',
                                    float: 'right',
                                    marginRight: '5px',
                                }}
                                onClick={handleDownloadCSV}
                            />
                        </Popover>
                        <Table
                            columns={siteColumns}
                            dataSource={siteData}
                            loading={loading}
                            pagination={
                                siteData.length > 0
                                    ? {
                                        current: currentPage,
                                        total: totalCount,
                                        pageSize: pageSize,
                                        onChange: (page) => setCurrentPage(page),
                                    }
                                    : false
                            }
                            scroll={{
                                x: "max-content", // Enables horizontal scrolling
                                y: 300,           // Set height to make the header fixed
                            }}
                            rowClassName={(record) =>
                                record.fullObject.REGISTRY_ID === selectedRegistryId
                                    ? 'highlighted-row'
                                    : ''
                            }
                            onChange={handleTableChange}
                        />

                    </TabPane>
                )}
                {!refineSearchActive && (
                    <TabPane tab="Opportunities" key="2">

                        <Popover
                            content="Max 5000 records can be downloaded"
                            placement="top"
                            trigger="hover"
                        >
                            <DownloadOutlined
                                style={{
                                    fontSize: 20,
                                    color: !hasDownloaded ? 'gray' : '#1890ff',
                                    cursor: !hasDownloaded ? 'not-allowed' : 'pointer',
                                    float: 'right',
                                    marginRight: '5px',
                                }}
                                onClick={handleOpportunityDownload}
                            />
                        </Popover>
                        <Table
                            columns={opportunityColumns}
                            dataSource={opportunityData}
                            loading={opportunityLoading}
                            pagination={
                                opportunityData.length > 0
                                    ? {
                                        current: opportunityPage,
                                        total: opportunityTotalCount,
                                        pageSize: opportunityPageSize,
                                        onChange: (page) => setOpportunityPage(page),
                                    }
                                    : false
                            }
                            scroll={{
                                x: "max-content",
                                y: 300,
                            }}
                            onChange={handleTableChangeOp}
                            showSorterTooltip={false}
                        />
                    </TabPane>
                )}

                {!refineSearchActive && groupName && showProjectTable && (
                    <TabPane tab="Project" key="3">
                        <Popover
                            content="Max 5000 records can be downloaded"
                            placement="top"
                            trigger="hover"
                        >
                            <DownloadOutlined
                                style={{
                                    fontSize: 20,
                                    color: !hasDownloaded ? 'gray' : '#1890ff',
                                    cursor: !hasDownloaded ? 'not-allowed' : 'pointer',
                                    float: 'right',
                                    marginRight: '5px',
                                }}
                                onClick={handleProjectDownload}
                            />
                        </Popover>

                        <Table
                            columns={projectColumns}
                            dataSource={
                                projectApiFailed
                                    ? [
                                        {
                                            key: "error",
                                            isErrorRow: true, // custom flag to detect error
                                        },
                                    ]
                                    : filteredProjectData
                            }
                            loading={projectLoading}
                            pagination={
                                !projectApiFailed && projectData.length > 0
                                    ? {
                                        current: projectPage,
                                        total: projectTotalCount,
                                        pageSize: projectPageSize,
                                        onChange: (page) => setProjectPage(page),
                                    }
                                    : false
                            }
                            scroll={{
                                x: "max-content",
                                y: 300,
                            }}
                            rowClassName={(record) =>
                                record.projectId === projectId ? 'highlighted-row' : ''
                            }
                            // Render a custom row if API failed
                            rowKey="key"
                        />

                    </TabPane>
                )}

                {refineSearchActive && activeRefineSearchType === "plant" && (
                    <TabPane tab={<span><SearchOutlined style={{ marginRight: 8 }} /> IIR Plant / Sites</span>} key="4">

                        <Popover
                            content="Max 100 records can be downloaded"
                            placement="top"
                            trigger="hover"
                        >
                            <DownloadOutlined
                                style={{
                                    fontSize: 20,
                                    color: plantResults.length === 0 ? "gray" : "#1890ff",
                                    cursor: plantResults.length === 0 ? "not-allowed" : "pointer",
                                    float: "right",
                                    marginRight: "5px",
                                }}
                                onClick={plantResults.length === 0 ? null : handlePlantDownload}
                            />
                        </Popover>
                        <Table
                            columns={plantColumns}
                            dataSource={plantResults}
                            loading={plantLoader} // ✅ loader for the table
                            rowKey="plantId"
                            scroll={{ x: "max-content", y: 300 }}
                            pagination={{
                                current: plantCurrentPage,
                                pageSize: pageSize,
                                total: plantTotalCount,
                                showSizeChanger: false, // fixed 100 rows per page
                            }}
                            onChange={handlePlantTableChange}
                            rowClassName={(record) =>
                                record.plantId === selectedPlantID ? 'highlighted-row' : ''
                            }
                        />

                    </TabPane>
                )}



                {refineSearchActive && activeRefineSearchType === "project" && (
                    <TabPane tab={<span><SearchOutlined style={{ marginRight: 8 }} /> IIR Projects</span>} key="5">

                        <Popover
                            content="Max 100 records can be downloaded"
                            placement="top"
                            trigger="hover"
                        >
                            <DownloadOutlined
                                style={{
                                    fontSize: 20,
                                    color: refineProjectResults.length === 0 ? "gray" : "#1890ff",
                                    cursor: refineProjectResults.length === 0 ? "not-allowed" : "pointer",
                                    float: "right",
                                    marginRight: "5px",
                                }}
                                onClick={refineProjectResults.length === 0 ? null : handleRefineProjectDownload}
                            />
                        </Popover>
                        <Table
                            columns={refineProjectColumns}
                            dataSource={refineProjectResults}
                            loading={refineProjectLoader} // ✅ loader for the table
                            rowKey="projectId"
                            scroll={{ x: "max-content", y: 300 }}
                            pagination={{
                                current: refineProjectCurrentPage,
                                pageSize: pageSize,
                                total: refineProjectTotalCount,
                                showSizeChanger: false, // fixed 100 rows per page
                            }}
                            onChange={handleProjectTableChange}
                            rowClassName={(record) =>
                                record.projectId === selectedProjectID ? 'highlighted-row' : ''
                            }

                        />
                    </TabPane>
                )}

            </Tabs>
        </>
    );
};

export default DataTable;
